import React, { useRef, useState, useCallback, useEffect } from 'react';

// Usando componentes Shadcn/Tailwind

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "src/@/components/ui/dialog";
import { Card } from 'src/@/components/ui/card';
import { Switch } from 'src/@/components/ui/switch';
import { Label } from 'src/@/components/ui/label';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { Button } from 'src/@/components/ui/button';
import { Textarea } from 'src/@/components/ui/textarea';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/@/components/ui/tooltip';
import { Drawer, DrawerContent } from 'src/@/components/ui/drawer';
import { Progress } from 'src/@/components/ui/progress';
import { Loader2 } from 'lucide-react';

import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
//hooks
import useResponsive from 'src/hooks/useResponsive';
//redux 
import {
	getChatsAtendimento,
	getChatsPendente,
	setDialogRespostas,
	setSelectedMessage,
	getCountsChats,
	setMensagensEnviar,
	resetMensagensEnviar,
	getChatInfoByChatId
} from 'src/redux/slices/chat';
import { setIsOnlineUsers } from 'src/redux/slices/staff';
import { useDispatch, useSelector } from 'src/redux/store';
//services
import { getSession } from "src/services/auth";
//components
import ModalMensagensRapidas from "src/components/_chats/chat/components/ModalMensagensRapidas";
import ModalTemplatesWhatsApp from "src/components/_chats/chat/components/ModalTemplatesWhatsApp";
import ModalSearchProduct from "src/sections/@chats/chat/Modals/ModalSearchProduct";
import RecordingTimer from "src/components/_chats/chat/components/RecordingTimer";
import Iconify from "src/components/Iconify";
import { UploadMultiFile } from 'src/components/upload';
import EmojiPicker from 'src/components/EmojiPicker';
//icons
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FaCheck, FaLessThanEqual } from "react-icons/fa";
import { verifyRules } from "src/utils/functions";
import { setModalAlerta } from "src/redux/slices/global";
///-----
import config from "src/config";
import MicRecorder from "mic-recorder-to-mp3";
const recorder = new MicRecorder({ bitRate: 128 })
//zui
import { RowInput } from 'src/components/forms/RowInput';
//actions
import v1_actionEnviarArquivoBuffer from "src/actions/v1/whatsapp/v1_actionEnviarArquivoBuffer";
import v2_actionEnviarAudioBuffer from "src/actions/v2/whatsapp/v2_actionEnviarAudioBuffer";
import actionCriarNotas from 'src/actions/chats/notas/actionCriarNotas';
import v1_actionEnviarMenagemWhatsapp from "src/actions/v1/whatsapp/v1_actionEnviarMenagemWhatsapp";
import v1_actionEnviarVozWhatsapp from "src/actions/v1/whatsapp/v1_actionEnviarVozWhatsapp";
import v1_actionEnviarProduto from "src/actions/v1/whatsapp/v1_actionEnviarProduto";
import v1_actionResponderMensagemWhatsapp from "src/actions/v1/whatsapp/v1_actionResponderMensagemWhatsapp";
import actionListaRespostasRapida from "src/actions/dashboard/respostas-rapidas/actionListaRespostasRapida";
import actionSendFileMeta from 'src/actions/chats/meta/actionSendFileMeta';
import actionSendMessageMeta from 'src/actions/chats/meta/actionSendMessageMeta';
import actionUploadFileMeta from 'src/actions/s3/actionUploadFileMeta';
import { initCacheFileSave, saveMessageToIDB } from 'src/helpers/cache.helper';
import ChatComponent from 'src/components/_chats/chat/components/ChatPage/ChatComponent';
import WhatsAppCountdownTimer from 'src/components/_chats/chat/components/WhatsAppCountdownTimer';
import v2_actionAnaliseAtendimento from 'src/actions/v2/ai/v2_actionAnaliseAtendimento';

//utils
import { removeHttpPrefix } from 'src/utils/chats.utils';
import { useToast } from 'src/@/components/ui/use-toast';
import { blobToBase64 } from 'src/helpers/audio.helper';
import * as Sentry from '@sentry/react';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu"
import Scrollbar from 'src/components/Scrollbar';
import axios from 'axios';
import { MessageSquareShare, Paperclip, Sparkles, Info, Mic, Send, X, Check, Maximize2, Minimize2 } from 'lucide-react';
import v1_actionUrlToBuffer from 'src/actions/global/v1_actionUrlToBuffer';

const MultiFileDialog = ({
	open,
	onOpenChange,
	chat,
	cliente,
	isDocument,
	loadingEnviarArquivos,
	preview,
	files,
	onEnviarArquivosBuffer,
	handleDropMultiFile,
	handleRemove,
	handleRemoveAll,
	changeIsDocument,
}) => {
	const { t } = useTranslation();
	const [showLimitsInfo, setShowLimitsInfo] = useState(false);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-2xl">
				<DialogHeader className="mt-4">
					<div className="flex items-center gap-4">
						<DialogTitle>{t('chat.upload.dialogTitle')}</DialogTitle>

						<Button
							onClick={() => setShowLimitsInfo(!showLimitsInfo)}
							className="h-6"
						>
							{t('chat.upload.fileLimit')}
							<Info width={18} height={18} />
						</Button>

					</div>
				</DialogHeader>
				<div className="flex flex-col items-center">
					{showLimitsInfo && (
						<div className="w-full mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
							<div className="flex items-start gap-2">
								<div className="text-blue-600 text-lg">📎</div>
								<div className="flex-1">
									<h4 className="font-semibold text-blue-800 text-sm mb-2">
										{t('chat.upload.limits.title')}
									</h4>
									<div className="space-y-1 text-xs text-blue-700">
										{chat?.canal === "whatsapp_business" ? (
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.imagesHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.videoHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.audioHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.documentsHtml', { size: '40 MB' }) }} />
											</>
										) : chat?.canal === "instagram" ? (
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.imagesHtml', { size: '5 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.videoHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.audioHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.documentsHtml', { size: '40 MB' }) }} />
											</>
										) : (
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.imagesHtml', { size: '5 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.videoHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.audioHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.documentsHtml', { size: '40 MB' }) }} />
											</>
										)}
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="flex flex-col space-y-4">
						<div className="space-y-4">
							<UploadMultiFile
								canal={chat?.canal}
								isStaff={false}
								cliente={cliente}
								isDocument={isDocument}
								changeIsDocument={changeIsDocument}
								loadingEnviarArquivos={loadingEnviarArquivos}
								showPreview={preview}
								files={files || []}
								onEnviarArquivos={onEnviarArquivosBuffer}
								onDrop={handleDropMultiFile}
								onRemove={handleRemove}
								onRemoveAll={handleRemoveAll}
							/>
						</div>
					</div>
				</div>

			</DialogContent>
		</Dialog>
	);
};

const DrawerAudio = ({ loading, handleCancelAudio, handleUploadAudio }) => (
	<div className="flex items-center gap-2 p-4">
		<Button
			variant="ghost"
			size="icon"
			aria-label="cancelRecording"
			disabled={loading}
			onClick={handleCancelAudio}
			className="h-10 w-10"
		>
			<X className="h-5 w-5 text-red-500" />
		</Button>

		{loading ? (
			<Loader2 className="h-6 w-6 animate-spin text-green-500 opacity-70" />
		) : (
			<RecordingTimer />
		)}

		<Button
			variant="ghost"
			size="icon"
			aria-label="sendRecordedAudio"
			onClick={handleUploadAudio}
			disabled={loading}
			className="h-10 w-10"
		>
			<Check className="h-5 w-5 text-green-500" />
		</Button>
	</div>
);

const NotesPopover = ({ open, setOpen, textNotes, setTextNotes, handleAddNote }) => {
	const { t } = useTranslation();
	return (
		<Popover onOpenChange={setOpen} open={open}>
			<PopoverTrigger asChild>
				<Button onClick={() => setOpen(true)} variant="secondary" className="h-7 bg-violet-100 flex-shrink-0">
					<Iconify className="sm:mr-1 text-violet-900" icon="fluent:note-add-16-filled" width={15} height={15} />
					<span className="hidden sm:inline">{t('chat.notes.newShort')}</span>
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-80 min-h-[200px]">
				<div className='flex flex-col gap-5'>
					<div className="w-full bg-neutral-100 p-2 rounded-sm flex flex-row justify-between items-center">
						<h4 className="font-medium leading-none">{t('chat.notes.createNew')}</h4>
						<Button onClick={() => setOpen(false)} variant="secondary" size="small">
							<Iconify icon="material-symbols:close" />
						</Button>
					</div>
					<div className="mt-2">
						<RowInput
							label={t('chat.notes.label')}
							input={
								<Textarea
									value={textNotes}
									onChange={(e) => setTextNotes(e.target.value)}
									rows={4}
									multiline
								/>
							}
						/>
					</div>
					<Button onClick={handleAddNote} className="w-full">
						{t('common:buttons.create')}
					</Button>
				</div>
			</PopoverContent>
		</Popover>
	);
};

const ChatBottomBar = ({ layoutMode, user, cliente, chat, mensagens, onOpenDrawerGpt, disabled, onCallbackResend, onCallbackAnalysis }) => {

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { selectedMessage, dialogRespostasRapidas, chatInfo, mensagensEnviar } = useSelector((state) => state.chat);
	const [loading, setLoading] = useState(false);
	const [text, setText] = useState("");
	const textareaRef = useRef(null);
	const [isExpanded, setIsExpanded] = useState(false);
	const [files, setFiles] = useState([]);
	const filesUrl = [];
	const [multiFile, setMultiFile] = useState(false);
	const [preview] = useState(false);
	const [loadingEnviarArquivos, setLoadingEnviarArquivos] = useState(false);
	const isDesktop = useResponsive('up', 'md');

	const [openDrawerAudio, setOpenDrawerAudio] = React.useState(false);
	const [loadingSendText, setLoadingSendText] = useState(false);
	const [assinarEnvio, setAssinarEnvio] = useState(true);
	const assinatura = '*_' + user.nomeFantasia + '_* \n';
	const assinaturaMeta = user.nomeFantasia + ':\n\n';
	const [pesquisaRespostaRapida, setPesquisaRespostaRapidas] = useState('');
	const [listaRepostasRapidas, setListaRespostasRapidas] = useState([]);
	const sendingRespostaRapidaRef = useRef(false);
	const [isDocument, setIsDocument] = useState(false);
	const [isFromMsgTemplate, setIsFromMsgTemplate] = useState(false);

	/// audio recorder v2
	const [recording, setRecording] = useState(false);
	const [audioURL, setAudioURL] = useState('');
	const mediaRecorderRef = useRef(null);
	const audioChunksRef = useRef([]);
	const [openPopoverNotes, setOpenPopoverNotes] = useState(false);
	const [textNotes, setTextNotes] = useState('');
	const [suggestion, setSuggestion] = useState("");
	const [dialogTemplates, setDialogTemplates] = useState(false);
	const [openModalProduct, setOpenModalProduct] = useState(false);
	const [loadingSuggestion, setLoadingSuggestion] = useState(false);
	const abortControllerRef = useRef(null);

	// Estado para habilitar/desabilitar copilot (persistido em localStorage)
	const [copilotEnabled, setCopilotEnabled] = useState(() => {
		const saved = localStorage.getItem('copilot_enabled');
		return saved !== null ? JSON.parse(saved) : false; // Desabilitado por padrão
	});

	const { toast } = useToast()

	const [loadingAnalysis, setLoadingAnalysis] = useState(false);

	// Persistir preferência do copilot
	const handleToggleCopilot = useCallback((enabled) => {
		setCopilotEnabled(enabled);
		localStorage.setItem('copilot_enabled', JSON.stringify(enabled));
		if (!enabled) {
			setSuggestion("");
		}
	}, []);

	// Comandos disponíveis para o copilot
	const COPILOT_COMMANDS = {
		'/r': { type: 'response', label: 'Gerar resposta baseada no contexto' },
		'/responda': { type: 'response', label: 'Gerar resposta baseada no contexto' },
		'/a': { type: 'analyze', label: 'Analisar conversa e sugerir resposta' },
		'/analise': { type: 'analyze', label: 'Analisar conversa e sugerir resposta' },
		'/s': { type: 'summary', label: 'Resumir conversa' },
		'/resuma': { type: 'summary', label: 'Resumir conversa' },
	};

	// Detectar se é um comando
	const detectCommand = useCallback((inputText) => {
		const trimmed = inputText.trim().toLowerCase();
		for (const [cmd, config] of Object.entries(COPILOT_COMMANDS)) {
			if (trimmed === cmd || trimmed.startsWith(cmd + ' ')) {
				const args = trimmed.slice(cmd.length).trim();
				return { ...config, cmd, args };
			}
		}
		return null;
	}, []);

	// Pegar contexto mínimo (só para comandos)
	const getMinimalContext = useCallback(() => {
		return mensagens
			.filter((item) => item.type === 'chat' && item.body)
			.slice(-6)
			.map((item) => `${item.fromMe ? 'A' : 'C'}: ${item.body?.substring(0, 150)}`)
			.join('\n');
	}, [mensagens]);

	const fetchSuggestion = useCallback(async (currentText) => {
		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}
		abortControllerRef.current = new AbortController();
		setLoadingSuggestion(true);

		try {
			const command = detectCommand(currentText);
			let messages;

			if (command) {
				// Modo COMANDO - usa contexto completo
				const context = getMinimalContext();

				if (command.type === 'response') {
					messages = [
						{ role: "system", content: `Gere uma resposta profissional para o cliente baseada no contexto.\nContexto:\n${context}` },
						{ role: "user", content: command.args || "Responda adequadamente" }
					];
				} else if (command.type === 'analyze') {
					messages = [
						{ role: "system", content: `Analise a conversa e sugira a melhor resposta.\nContexto:\n${context}` },
						{ role: "user", content: command.args || "Qual a melhor resposta?" }
					];
				} else if (command.type === 'summary') {
					messages = [
						{ role: "system", content: `Resuma a conversa em 1-2 frases.\nContexto:\n${context}` },
						{ role: "user", content: "Resuma" }
					];
				}
			} else {
				// Modo AUTOCOMPLETE - mínimo de tokens
				// Só pega última mensagem do cliente para contexto mínimo
				const lastClientMsg = mensagens
					.filter(m => m.type === 'chat' && !m.fromMe && m.body)
					.slice(-1)[0]?.body?.substring(0, 100) || '';

				messages = [
					{
						role: "user",
						content: `Complete:${lastClientMsg ? ` [Cliente: ${lastClientMsg}]` : ''} "${currentText}"`
					}
				];
			}

			const response = await axios.post(
				`https://api.lais.app/api/v3/${cliente._id}/ai/copilot/completions`,
				{
					messages,
					model: "basic",
					temperature: command ? 0.4 : 0.1,
					purpose: "copilot",
					description: command ? command.type : "autocomplete"
				},
				{
					signal: abortControllerRef.current.signal,
					timeout: 6000
				}
			);

			const generatedText = response.data?.data?.trim() || "";

			if (generatedText && generatedText.length > 0 && generatedText.length < 500) {
				setSuggestion(generatedText);
			} else {
				setSuggestion("");
			}
		} catch (error) {
			if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELED') {
				console.error("Erro copilot:", error);
			}
			setSuggestion("");
		} finally {
			setLoadingSuggestion(false);
		}
	}, [cliente._id, detectCommand, getMinimalContext, mensagens]);

	// Debounce effect para buscar sugestões
	useEffect(() => {
		if (!copilotEnabled) {
			setSuggestion("");
			return;
		}

		const command = detectCommand(text);

		// Para comandos: buscar imediatamente após digitar o comando
		if (command) {
			const debounceTimeout = setTimeout(() => {
				fetchSuggestion(text);
			}, 400);
			return () => {
				clearTimeout(debounceTimeout);
				if (abortControllerRef.current) abortControllerRef.current.abort();
			};
		}

		// Para autocomplete: só buscar se texto > 8 chars (reduz chamadas)
		if (text.length < 8) {
			setSuggestion("");
			return;
		}

		if (loadingSendText || shouldBlockWhatsAppBusiness()) {
			return;
		}

		const debounceTimeout = setTimeout(() => {
			fetchSuggestion(text);
		}, 500);

		return () => {
			clearTimeout(debounceTimeout);
			if (abortControllerRef.current) abortControllerRef.current.abort();
		};
	}, [text, loadingSendText, fetchSuggestion, copilotEnabled, detectCommand]);

	// Limpar sugestão quando o componente desmontar
	useEffect(() => {
		return () => {
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}
		};
	}, []);

	const handleChangeAssinarEnvio = (event) => {
		setAssinarEnvio(event);
	};

	const buscarListaResponstasRapidas = async () => {
		try {
			const res = await actionListaRespostasRapida(user.clienteId, user.id);
			setListaRespostasRapidas(res.data.respostas);
		} catch (error) {
			console.log('error', error)
		}
	}

	const handleClickOpenDialogRespostasRapidas = () => {
		dispatch(setDialogRespostas(true));
		buscarListaResponstasRapidas()
	}

	const handleOnPaste = (event) => {
		const items = (event.clipboardData || event.originalEvent.clipboardData).items;
		let blob = null;
		for (let i = 0; i < items.length; i++) {
			if (items[i].type.indexOf("image") === 0) {
				blob = items[i].getAsFile();
			}
		}

		if (blob !== null) {
			setFiles([Object.assign(blob, { preview: URL.createObjectURL(blob) })])
			setMultiFile(true);
			const reader = new FileReader();
			reader.onload = function () {
				// console.log(event.target.result); 
				// console.log(event.target);
				//  setSrc(event.target.result);
			};
			reader.readAsDataURL(blob);
		}
	};


	async function uploadAndGetUrlMeta() {
		if (files.length > 0) {
			for (let file of files.map(item => item)) {
				console.log('file', file)
				var formData = new FormData();
				var imagefile = file;
				formData.append("file", imagefile);

				try {
					let querys = `?path=meta/instagram/${chat._id}`
					const response = await actionUploadFileMeta(formData, querys)
					if (!response.data.error) {
						filesUrl.push({ key: response.data.data.key, type: file.type })
						return filesUrl;
					}

				} catch (error) {
					console.log('erro ao upload arquivo', error)
				}

			}
		}
	}


	async function uploadAudioAndGetUrlMeta(file) {
		if (file) {
			var formData = new FormData();
			formData.append("file", file);
			try {
				console.log('INICIANDO UPLOAD DE ARQUIVOS 2', formData)
				let querys = `?path=meta/instagram/${chat._id}`
				const response = await actionUploadFileMeta(formData, querys)
				if (!response.data.error) {
					return { key: response.data.data.key, type: file.type, tipo: "audio" }
				}
			} catch (error) {
				console.log('erro ao upload arquivo', error)
			}
		}
	}

	const handleDropMultiFile = useCallback(
		(acceptedFiles) => {
			setFiles(acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));
			setMultiFile(true);
		},
		[setFiles]
	);

	const handleRemoveAll = () => {
		setFiles([]);
	};

	const handleRemove = (file) => {
		const filteredItems = files.filter((_file) => _file !== file);
		setFiles(filteredItems);
	};

	const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
		onDrop: (acceptedFiles, rejectedFiles) => {
			console.log('Accepted files:', acceptedFiles);
			console.log('Rejected files:', rejectedFiles);
			if (acceptedFiles && acceptedFiles.length > 0) {
				setMultiFile(true);
				setFiles(acceptedFiles.map(file => Object.assign(file, { preview: URL.createObjectURL(file) })));
			}
		},
		onDropAccepted: (files) => {
			console.log('Files accepted:', files);
		},
		onDropRejected: (files) => {
			console.log('Files rejected:', files);
		}
	});

	const toggleDrawer = () => () => {
		setOpenDrawerAudio(true);
	};

	async function onResponderMensagemWhatsapp(phone, meesageId, message, clientMessageId) {
		try {
			let data = {
				phone: phone,
				messageId: meesageId,
				message: message,
				...(clientMessageId && { clientMessageId }),
			};
			const querys = `?sessao=${chatInfo.sessao}&canal=${chatInfo.canal}`;
			await v1_actionResponderMensagemWhatsapp(querys, data);
		} catch (error) {
			console.log(error);
		}
	}

	function applyFilter(tableData, filterName) {
		if (filterName) {
			tableData = tableData.filter(
				(item) =>
					item.titulo.toLowerCase().indexOf(filterName.toLowerCase()) !== -1 ||
					item.resposta.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
			);
		}
		return tableData;
	}
	const dataRespostasRapidasFiltered = applyFilter(listaRepostasRapidas, pesquisaRespostaRapida);

	const onChangeText = e => {
		setText(e.target.value);
		// Reset da flag quando o usuário edita o texto manualmente
		if (isFromMsgTemplate) {
			setIsFromMsgTemplate(false);
		}
		// Limpar sugestão quando o texto mudar significativamente
		if (suggestion && !e.target.value.startsWith(text)) {
			setSuggestion("");
		}
	}

	useEffect(() => {
		const ta = textareaRef.current;
		if (!ta) return;
		if (isExpanded) {
			ta.style.height = '';
			return;
		}
		ta.style.height = 'auto';
		const maxHeight = 200;
		ta.style.height = `${Math.min(ta.scrollHeight, maxHeight)}px`;
	}, [text, isExpanded]);

	// Função para verificar se deve bloquear por falta de lastDateMsgClient (apenas WhatsApp Business)
	const shouldBlockForMissingLastDate = () => {
		return chat?.canal === "whatsapp_business" && !chat?.lastDateMsgClient;
	};

	// Função para verificar se deve bloquear WhatsApp Business (falta de lastDateMsgClient ou tempo expirado)
	const shouldBlockWhatsAppBusiness = () => {
		return chat?.canal === "whatsapp_business" && (shouldBlockForMissingLastDate() || isChatTimeExpired());
	};

	// Função para verificar se o tempo do chat expirou
	const isChatTimeExpired = () => {
		if (!chat?.lastDateMsgClient || !chat?.canal) return false;

		const now = new Date();
		const lastMessageDate = new Date(chat.lastDateMsgClient);

		// Adiciona 24 horas à data da última mensagem
		const expirationDate = new Date(lastMessageDate.getTime() + (24 * 60 * 60 * 1000));

		return now.getTime() > expirationDate.getTime();
	};

	// Função para lidar com seleção de template
	const handleSelecionouTemplate = (template) => {
		if (template.tipo === 'texto') {
			setText(template.resposta);
			setIsFromMsgTemplate(true);
			setDialogTemplates(false);
		}
	};

	async function sendMessage() {
		const clientMessageId = (typeof crypto !== 'undefined' && crypto.randomUUID)
			? crypto.randomUUID()
			: `${Date.now()}_${Math.random().toString(36).slice(2)}`;
		let textToSend = cliente?.config?.chats?.removeHttp ? removeHttpPrefix(text) : text;
		if (chat.canal === "instagram") {
			try {
				let querys = `?sessao=${chat.sessao}&canal=instagram`;
				let body = {
					userId: chat.instagramUser?.id,
					message: user.nomeFantasia !== "" ? text : text,
					clientMessageId,
					...(isFromMsgTemplate && { fromMsgTemplate: true })
				}
				setText('');
				setSuggestion("");
				setIsFromMsgTemplate(false);
				v1_actionEnviarMenagemWhatsapp(querys, body);
				dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
				// dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
				// dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));

				setLoadingSendText(false);
			} catch (error) {
				alert(t('chat.errors.sendFailed'))
			}
		} else {
			if (text === '' || text === '\n' || text === ' ' || text === ' \n') {
				setText('');
				return;
			}
			if (selectedMessage) {
				onResponderMensagemWhatsapp(chat.numeroCliente, selectedMessage.id, assinarEnvio && user.nomeFantasia !== "" ? assinatura + text : text, clientMessageId);
				setText('');
				setSuggestion("");
				dispatch(setSelectedMessage({}));
				setLoadingSendText(false);
				dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
				return;

			} else {
				try {
					let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
					let body;
					let dataPreSend = { type: 'chat', isMedia: false, };
					if (chat.canal === "whatsapp") {
						body = {
							phone: chat.numeroCliente,
							message: assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend,
							clientMessageId,
							...(isFromMsgTemplate && { fromMsgTemplate: true })
						}
					} else if (chat.canal === "whatsapp_business") {
						body = {
							clientMessageId,
							scope: {
								"messaging_product": "whatsapp",
								"recipient_type": "individual",
								"to": chat.numeroCliente,
								"type": "text",
								"text": {
									"body": assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend
								}
							}
						}
					}
					setText('');
					setSuggestion("");
					setIsFromMsgTemplate(false);
					setMensagensEnviarRedux(dataPreSend);
					const response = await v1_actionEnviarMenagemWhatsapp(querys, body);
					// if(chat.canal === "whatsapp_business"){
					// 	if(response.data.data.send){
					// 		dataPreSend.ack = 2;
					// 		dataPreSend.preSend = false;
					// 	}
					// }

					dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
				} catch (error) {
					if (error?.response?.status === 400) {
						const responseError = error.response?.data;
						if (responseError.numberNotExists) {
							dispatch(setModalAlerta({
								open: true,
								titulo: t('chat.errors.sendFailed'),
								mensagem: t('chat.errors.numberNotExists'),
							}))
						} else if (responseError.statusConexao === "Disconnected") {
							dispatch(setModalAlerta({
								open: true,
								titulo: config.erroDesconexaoWhatsapp.titulo,
								mensagem: config.erroDesconexaoWhatsapp.mensagem,
							}))
						}
					} else {
						toast({
							variant: 'destructive',
							description: t('notifications:toast.sendErrorCode', { code: error?.response?.status || 'NF01' }),
						});
						setText('');
					}
					Sentry.withScope(scope => {
						scope.setTag("section", "sendMessage");
						scope.setLevel("error");
						scope.setExtra("user", user);
						scope.setExtra("chat", chat);
						scope.setExtra("message", {
							phone: chat.numeroCliente,
							message: assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend
						});
						scope.setExtra("cliente", cliente);
						Sentry.captureException(error);
					});
					setText('');
					setLoadingSendText(false);
					dispatch(resetMensagensEnviar());
					await saveMessageToIDB('error_msg_send', {
						"ack": -1,
						"preSend": false,
						"body": assinarEnvio && user.nomeFantasia !== "" ? assinatura + text : text,
						"chatId": `${chat.numeroCliente}`,
						"content": assinarEnvio && user.nomeFantasia !== "" ? assinatura + text : text,
						"from": `${cliente.numero}@c.us`,
						"fromMe": true,
						"mimeType": false,
						"id": `${chat._id}_${Math.floor((new Date()).getTime() / 1000) + Math.random().toString(15).substring(2, 7)}`,
						"isGroupMsg": false,
						"isMedia": false,
						"sender": {
							"formattedName": "",
							"id": `${cliente.numero}@c.us`,
							"isMe": true,
							"profilePicThumbObj": null,
							"pushname": "",
							"verifiedName": ""
						},
						"t": new Date().getTime() / 1000,
						"timestamp": new Date().getTime() / 1000,
						"to": `${chat.numeroCliente}@c.us`,
						"type": "chat",
						"cliente_id": user.clienteId,
						"chat_id": chat._id,
						"error_msg": true,
					});

					onCallbackResend();

				}
			}

		}
	}

	async function setMensagensEnviarRedux(props) {
		const { type, isMedia, mimeType, erroMsg, ack = 6, preSend = true } = props;
		let newId = `true_${chat.numeroCliente}_${Math.floor((new Date()).getTime() / 1000) + Math.random().toString(15).substring(2, 7)}`;
		const novaData = new Date();
		try {
			let data = {
				"ack": ack,
				"preSend": preSend,
				"body": assinarEnvio && user.nomeFantasia !== "" ? assinatura + text : text,
				"chatId": `${chat.numeroCliente}`,
				"content": assinarEnvio && user.nomeFantasia !== "" ? assinatura + text : text,
				"from": `${cliente.numero}@c.us`,
				"fromMe": true,
				"mimeType": mimeType,
				"id": newId,
				"isGroupMsg": false,
				"isMedia": isMedia,
				"sender": {
					"formattedName": "",
					"id": `${cliente.numero}@c.us`,
					"isMe": true,
					"profilePicThumbObj": null,
					"pushname": "",
					"verifiedName": ""
				},
				"t": novaData.getTime() / 1000,
				"timestamp": novaData.getTime() / 1000,
				"to": `${chat.numeroCliente}@c.us`,
				"type": type,
				"cliente_id": user.clienteId,
				"chat_id": chat._id
			}
			dispatch(setMensagensEnviar(data))
		} catch (error) {
			console.log(error)
		}

	}

	async function handleSelecinouRespostaRapida(resposta) {
		if (resposta.tipo === 'texto') {
			setText(resposta.resposta);
			setIsFromMsgTemplate(true);
			dispatch(setDialogRespostas(false));
		} else {
			if (sendingRespostaRapidaRef.current) return;
			sendingRespostaRapidaRef.current = true;
			setLoadingSendText(true);
			dispatch(setDialogRespostas(false));
			if (resposta.files.length === 0) {
				setLoadingSendText(false);
				sendingRespostaRapidaRef.current = false;
				toast({
					variant: 'destructive',
					description: t('notifications:toast.quickReplyNoFiles'),
				});


				return;
			}
			let key = resposta.files.length > 0 ? resposta.files[0].key : '';
			let type = resposta.files.length > 0 ? resposta.files[0].type : '';
			const res_buffer = await v1_actionUrlToBuffer(`https://lais-app.s3.us-east-2.amazonaws.com/${key}`)
			let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;

			try {
				if (type === 'audio/mp3') {
					await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3' })

					// Criar FormData para áudio
					const formData = new FormData();
					const filename = `${new Date().getTime()}_audio.mp3`;
					const blob = new Blob([res_buffer.data], { type: 'audio/mp3' });
					formData.append("filename", filename);
					formData.append("file", blob);
					formData.append("phone", chat.numeroCliente);

					await v2_actionEnviarAudioBuffer(querys, formData);
					setLoadingEnviarArquivos(false);
					setLoadingSendText(false);
				} else {
					// Criar FormData para outros arquivos
					const formData = new FormData();
					const filename = `${new Date().getTime()}_${cliente?.nome || 'arquivo'}`;
					const blob = new Blob([res_buffer.data], { type: type });
					formData.append("filename", filename);
					formData.append("file", blob);
					formData.append("phone", chat.numeroCliente);

					await v1_actionEnviarArquivoBuffer(querys, formData);
				}
				toast({
					description: t('notifications:toast.sentSuccess'),
				});
				dispatch(resetMensagensEnviar());
				setLoadingEnviarArquivos(false);
				setLoadingSendText(false);

			} catch (error) {
				console.log('error', error)
				toast({
					variant: 'destructive',
					description: t('notifications:toast.sendError'),
				});

				dispatch(resetMensagensEnviar());
				setLoadingEnviarArquivos(false);
				setLoadingSendText(false);
				setIsFromMsgTemplate(false);
			} finally {
				sendingRespostaRapidaRef.current = false;
			}
		}
	}

	async function onEnviarArquivosBuffer() {
		if (files.length > 0) {
			setLoadingEnviarArquivos(true);

			if (chat.canal === "instagram") {
				setLoadingEnviarArquivos(true);
				setMultiFile(false);
				setFiles([]);
				await uploadAndGetUrlMeta();
				for (const file of filesUrl.map(item => item)) {
					setLoadingEnviarArquivos(false);

					let querys = `?sessao=${chat.sessao}&canal=instagram`;
					let body = {
						scope: {
							messageType: "response",
							type: validaTipoArquivo(file.type),
							instagramUserId: chat.instagramUser?.id,
							url: `https://lais-app.s3.us-east-2.amazonaws.com/${file.key}`,

						}
					};

				}
				setLoadingEnviarArquivos(false);

			} else {
				try {
					await setMensagensEnviarRedux({ type: 'video', isMedia: true, mimeType: 'video/mp4' })
					setMultiFile(false);
					for (let file of files.map(item => item)) {
						const filenameFile = file.name;

						if (isDocument) {

							try {
								const formData = new FormData();
								const filename = `${new Date().getTime()}_${filenameFile}`;
								formData.append("filename", filename);
								formData.append("file", file);
								formData.append("isDocument", true);
								formData.append("phone", chat.numeroCliente);
								let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;


								await v1_actionEnviarArquivoBuffer(querys, formData);
								dispatch(resetMensagensEnviar());
								toast({
									description: t('notifications:toast.sentSuccess'),
								});

							} catch (error) {

								if (error?.response?.status === 400) {
									const responseError = error?.response?.data;
									if (responseError?.statusConexao === "Disconnected") {
										dispatch(setModalAlerta({
											open: true,
											titulo: config.erroDesconexaoWhatsapp.titulo,
											mensagem: config.erroDesconexaoWhatsapp.mensagem,
										}))
									}
								}
								toast({
									variant: 'destructive',
									description: t('notifications:toast.sendError'),
								});

								dispatch(resetMensagensEnviar())
								Sentry.withScope(scope => {
									scope.setTag("section", "onEnviarArquivosBuffer");
									scope.setLevel("error");
									scope.setExtra("user", user);
									scope.setExtra("chat", chat);
									scope.setExtra("cliente", cliente);
									Sentry.captureException(error);
								});
							}


						} else {
							try {
								const formData = new FormData();
								const filename = `${new Date().getTime()}_${filenameFile}`;
								formData.append("filename", filename);
								formData.append("file", file);
								formData.append("phone", chat.numeroCliente);
								let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;

								await v1_actionEnviarArquivoBuffer(querys, formData);
								dispatch(resetMensagensEnviar());
								toast({
									description: t('notifications:toast.sentSuccess'),
								});

							} catch (error) {
								if (error?.response?.status === 400) {
									const responseError = error?.response?.data;
									if (responseError?.statusConexao === "Disconnected") {
										dispatch(setModalAlerta({
											open: true,
											titulo: config.erroDesconexaoWhatsapp.titulo,
											mensagem: config.erroDesconexaoWhatsapp.mensagem,
										}))
									}
								}
								toast({
									variant: 'destructive',
									description: t('notifications:toast.sendError'),
								});

								dispatch(resetMensagensEnviar())
								Sentry.withScope(scope => {
									scope.setTag("section", "onEnviarArquivosBuffer");
									scope.setLevel("error");
									scope.setExtra("user", user);
									scope.setExtra("chat", chat);
									scope.setExtra("cliente", cliente);
									Sentry.captureException(error);
								});
							}

						}
					}
				} finally {
					setLoadingEnviarArquivos(false);
					setMultiFile(false);
					setFiles([]);
				}
			}
		}
	}


	function validaTipoArquivo(mime) {
		const includesImage = ["image/png", "image/jpg", "image/jpeg"];
		const includesVideo = ["video/webm", "video/ogg", "video/mp4", "video/avi"];
		const includesAudio = ["audio/webm", "audio/ogg", "audio/wav", "audio/mpeg", "audio/mp3"];

		if (includesImage.includes(mime)) {
			return "image";
		} else if (includesVideo.includes(mime)) {
			return "video";
		} else if (includesAudio.includes(mime)) {
			return "audio";
		}
	}

	const v2_startRecording = async () => {
		if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
			toast({
				variant: 'destructive',
				description: t('chat.audio.notSupported'),
			});
			return;
		}

		try {
			const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
			mediaRecorderRef.current = new MediaRecorder(stream);
			mediaRecorderRef.current.start();

			mediaRecorderRef.current.ondataavailable = (event) => {
				audioChunksRef.current.push(event.data);
			};

			setRecording(true);
		} catch (err) {
			console.error('Erro ao acessar microfone:', err.name, err.message);

			// Tenta fallback com dispositivo explícito e sem filtros de áudio
			if (err.name === 'NotReadableError' || err.name === 'NotAllowedError' || err.name === 'AbortError') {
				try {
					const devices = await navigator.mediaDevices.enumerateDevices();
					const audioDevices = devices.filter(d => d.kind === 'audioinput');
					console.log('Dispositivos de áudio encontrados:', audioDevices);

					if (audioDevices.length === 0) {
						toast({
							variant: 'destructive',
							description: t('chat.audio.noMicrophone'),
						});
						return;
					}

					// Tenta com o primeiro dispositivo explicitamente
					const stream = await navigator.mediaDevices.getUserMedia({
						audio: {
							deviceId: { exact: audioDevices[0].deviceId },
							echoCancellation: false,
							noiseSuppression: false,
							autoGainControl: false,
						}
					});

					mediaRecorderRef.current = new MediaRecorder(stream);
					mediaRecorderRef.current.start();
					mediaRecorderRef.current.ondataavailable = (event) => {
						audioChunksRef.current.push(event.data);
					};
					setRecording(true);
					return;
				} catch (retryErr) {
					console.error('Fallback também falhou:', retryErr.name, retryErr.message);
				}
			}

			const mensagensErro = {
				NotAllowedError: t('chat.audio.permissionDenied'),
				NotFoundError: t('chat.audio.noMicrophone'),
				NotReadableError: t('chat.audio.microphoneInUse'),
			};

			toast({
				variant: 'destructive',
				description: mensagensErro[err.name] || t('chat.audio.genericError', { code: err.name }),
			});
		}
	};

	const v2_handleCancelAudio = async () => {
		try {
			mediaRecorderRef.current.stop();
			mediaRecorderRef.current.onstop = async () => {
				setRecording(false);
				audioChunksRef.current = [];
				setLoading(false);
			}
		} catch (err) {
			console.log(err);
		}
	};

	// const resendAudio = async (messageId, blob) => {
	// 	if (chat.canal === "whatsapp") {
	// 		try {
	// 			await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3' });

	// 			setLoading(true);
	// 			const formData = new FormData();
	// 			const filename = `${new Date().getTime()}.mp3`;
	// 			formData.append("filename", filename);
	// 			formData.append("file", blob);
	// 			formData.append("phone", chat.numeroCliente);
	// 			let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
	// 			await v2_actionEnviarAudioBuffer(querys, formData);
	// 			dispatch(resetMensagensEnviar())
	// 			await removeMessageFromIDB('error_msg_send', messageId)
	// 		} catch (err) {
	// 			setLoading(false);
	// 			toast({
	// 				variant: 'destructive',
	// 				description: t('notifications:toast.sendError'),
	// 			});

	// 		}

	// 	}
	// }


	const v2_stopRecording = async () => {

		let audioBlobSave;
		mediaRecorderRef.current.stop();
		mediaRecorderRef.current.onstop = async () => {
			if (chat.canal === "whatsapp" || chat.canal === "whatsapp_business") {
				try {
					await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3' });
					const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/mp3' });
					audioBlobSave = audioBlob;
					setLoading(true);
					const formData = new FormData();
					const filename = `${new Date().getTime()}.mp3`;
					formData.append("filename", filename);
					formData.append("file", audioBlob);
					formData.append("phone", chat.numeroCliente);
					formData.append("isVoice", "true");
					let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
					if (chat.canal === "whatsapp_business") {
						await v1_actionEnviarArquivoBuffer(querys, formData);
					} else {
						await v2_actionEnviarAudioBuffer(querys, formData);
					}

					dispatch(resetMensagensEnviar())

				} catch (err) {

					const messageId = `${chat._id}_${Math.floor((new Date()).getTime() / 1000)}_${Math.random().toString(15).substring(2, 7)}`;
					// blob to base64
					const base64Audio = await blobToBase64(audioBlobSave);
					console.log('base64Audio', base64Audio)
					await initCacheFileSave(messageId, base64Audio, 'audio/mp3');

					// Salva a referência da mensagem
					await saveMessageToIDB('error_msg_send', {
						"ack": -1,
						"preSend": false,
						"body": null,
						"chatId": `${chat.numeroCliente}`,
						"content": messageId,
						"from": `${cliente.numero}@c.us`,
						"fromMe": true,
						"mimeType": "audio/mp3",
						"id": messageId,
						"isGroupMsg": false,
						"isMedia": true,
						"type": "ptt",
						"sender": {
							"formattedName": "",
							"id": `${cliente.numero}@c.us`,
							"isMe": true,
							"profilePicThumbObj": null,
							"pushname": "",
							"verifiedName": ""
						},
						"t": new Date().getTime() / 1000,
						"timestamp": new Date().getTime() / 1000,
						"to": `${chat.numeroCliente}@c.us`,
						"cliente_id": user.clienteId,
						"chat_id": chat._id,
						"error_msg": true,
					});
					dispatch(resetMensagensEnviar())
					setLoading(false);
					setRecording(false);
					Sentry.captureException(err);

				}

			}
			else if (chat.canal === "instagram") {
				try {
					// await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3' });
					const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/mp3' });
					console.log('audioBlob', audioBlob)
					setLoading(true);
					// const file = new File(audioBlob, "audio.mp3", {
					// 	type: audioBlob.type,
					// 	lastModified: Date.now()
					// });
					const res = await uploadAudioAndGetUrlMeta(audioBlob);
					// let querys = `?sessao=${chat.sessao}&canal=instagram`;
					// let body = {
					// 	scope: {
					// 		messageType: "response",
					// 		type: 'audio',
					// 		instagramUserId: chat.instagram_user_id,
					// 		url: `https://lais-app.s3.us-east-2.amazonaws.com/${res.key}`,

					// 	}
					// };
					// await v1_actionEnviarArquivoWhatsapp(querys, body);
					dispatch(resetMensagensEnviar())
				} catch (err) {
					console.log('error', err);
				}

			}
			setRecording(false);
			setLoading(false);
			//setAudioURL(audioUrl);
			setRecording(false);
			audioChunksRef.current = [];
		};
	};


	const handleKeyDown = (event) => {
		if (!event.shiftKey && event.key === 'Enter') {
			event.preventDefault();
			sendMessage();
		} else if (event.key === "Tab" && suggestion) {
			event.preventDefault();
			const command = detectCommand(text);
			if (command) {
				// Para comandos: substitui tudo pela sugestão
				setText(suggestion);
			} else {
				// Para autocomplete: concatena
				const newText = text + " " + suggestion;
				setText(newText.trim());
			}
			setSuggestion("");
		}
	};

	const handleKeyUp = (event) => {
		// Outras lógicas que você possa ter no handleKeyUp
	};


	async function handleAddNote() {
		try {
			let data = {
				nota: {
					body: textNotes,
					usuario_id: user.id,
					date: new Date()
				}
			}
			await actionCriarNotas(chat._id, data)
			setTextNotes('');
			dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, false));
			dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
			setOpenPopoverNotes(false);
			toast({
				description: t('notifications:toast.noteAddedSuccess'),
			});

		} catch (error) {
			toast({
				variant: 'destructive',
				description: t('notifications:toast.sendError'),
			});

		}
	}

	const onCreateAnalysis = async () => {
		try {
			setLoadingAnalysis(true);

			enqueueSnackbar(t('notifications:toast.analysisSuccess'), {
				variant: 'success',
				anchorOrigin: {
					vertical: 'bottom',
					horizontal: 'center'
				},
				autoHideDuration: 3000
			});

			await v2_actionAnaliseAtendimento({
				chat_id: chat._id,
				cliente_id: user.clienteId
			});

		} catch (error) {
			console.error('Erro na análise:', error);
			enqueueSnackbar(t('notifications:toast.analysisError'), {
				variant: 'error',
				anchorOrigin: {
					vertical: 'bottom',
					horizontal: 'center'
				}
			});
		} finally {
			setLoadingAnalysis(false);
		}
	};

	const handleSelectProduct = async (product) => {
		try {
			// setOpenModalProduct(false); 
			// Should close modal? The previous code didn't close it explicitly here, maybe the modal handles it or it stays open?
			// The modal prop `onSelect` is called. Let's see `ModalSearchProduct` usage.
			// Line 1249: onSelect={handleSelectProduct}. And onClose is separate.
			// Usually onSelect implies action taken. If I want to close it, I should call setOpenModalProduct(false).
			// But maybe the user wants to send multiple?
			// The previous logic just added text to input.
			// I'll assume closing it or keeping it is fine. I'll just keep the API logic.

			setLoadingSendText(true);
			// await axios.post(`/api/v1/chats/canais/enviar-produto?sessao=${chat.sessao}&canal=${chat.canal}`, {
			// 	produtoId: product._id,
			// 	phone: chat.numeroCliente
			// });
			const querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
			await v1_actionEnviarProduto(querys, {
				produtoId: product._id,
				phone: chat.numeroCliente
			});

			toast({
				description: t('notifications:toast.productSentSuccess'),
			});
			setOpenModalProduct(false);

		} catch (error) {
			console.error(error);
			toast({
				variant: 'destructive',
				description: t('notifications:toast.productSendError'),
			});
		} finally {
			setLoadingSendText(false);
		}
	};

	return (
		<Card {...getRootProps()} className={`mx-2 ${layoutMode === 'sidebar' ? 'mb-20' : 'mb-2'}`} style={{
			cursor: 'pointer',
			border: isDragActive ? '2px dashed #0aafd9' : '',
		}}>
			{!isDesktop && recording && (
				<Drawer open={openDrawerAudio} onOpenChange={(open) => !open && toggleDrawer(false)()}>
					<DrawerContent>
						{drawerAudio()}
					</DrawerContent>
				</Drawer>
			)}

			<MultiFileDialog
				open={multiFile}
				files={files}
				onOpenChange={(open) => {
					setMultiFile(open);
					if (!open) setLoadingEnviarArquivos(false);
				}}
				chat={chat}
				cliente={cliente}
				isDocument={isDocument}
				loadingEnviarArquivos={loadingEnviarArquivos}
				preview={preview}
				onEnviarArquivosBuffer={onEnviarArquivosBuffer}
				handleDropMultiFile={handleDropMultiFile}
				handleRemove={handleRemove}
				handleRemoveAll={handleRemoveAll}
				changeIsDocument={checked => {
					setIsDocument(checked);
					console.log('checked', checked);
				}}
			/>

			<ModalMensagensRapidas
				dialogRespostasRapidas={dialogRespostasRapidas}
				onClose={() => {
					dispatch(setDialogRespostas(false))
				}}
				data={dataRespostasRapidasFiltered}
				onSelect={resposta => handleSelecinouRespostaRapida(resposta)}
				changePesquisa={e => setPesquisaRespostaRapidas(e.target.value)}
				setPesquisa={setPesquisaRespostaRapidas}
				pesquisa={pesquisaRespostaRapida}
			/>

			<ModalTemplatesWhatsApp
				dialogTemplates={dialogTemplates}
				onClose={() => setDialogTemplates(false)}
				onSelect={handleSelecionouTemplate}
				chat={chat}
			/>

			<ModalSearchProduct
				open={openModalProduct}
				onClose={() => setOpenModalProduct(false)}
				onSelect={handleSelectProduct}
				ownerId={cliente?._id || user.clienteId}
			/>


			{!!selectedMessage && (
				<div
					class="p-2 flex flex-row bg-slate-50 border-slate-200 rounded border items-center justify-center gap-2 ">
					<Scrollbar className="flex-1 max-h-32 overflow-y-auto">
						<div class="content flex-1 flex items-center justify-center">
							<ChatComponent
								isMe={selectedMessage.fromMe ? "right" : "left"}
								isWarning={!selectedMessage?.body && selectedMessage.type !== "chat" && !["ptt", "audio"].includes(selectedMessage.type)}
								chat={chatInfo}
								message={selectedMessage}
								isReply={true}
								selectMessageId={() => {
									// Removido scrollMessagesToBottom() que estava causando conflito
									dispatch(setSelectedMessage(selectedMessage))
								}}
							/>
						</div>
					</Scrollbar>
					<Button
						className="w-8 h-8 mr-12"
						onClick={() => dispatch(setSelectedMessage({}))}
					>
						<Iconify icon="material-symbols:close" className="icon-arrow-up" />
					</Button>
				</div>
			)}

			{/* Mostrar comandos disponíveis quando digitar "/" */}
			{copilotEnabled && text === '/' && (
				<div className="relative w-full">
					<div className="py-2 px-2 bg-slate-50 border border-slate-200 rounded">
						<p className="text-[11px] text-slate-500 mb-1">{t('chat.copilot.commandsAvailable')}</p>
						<div className="flex flex-wrap gap-1">
							<span className="text-[11px] bg-violet-100 text-violet-700 px-2 py-0.5 rounded">/r</span>
							<span className="text-[11px] text-slate-500">{t('chat.copilot.commands.response')}</span>
							<span className="text-[11px] bg-violet-100 text-violet-700 px-2 py-0.5 rounded ml-2">/a</span>
							<span className="text-[11px] text-slate-500">{t('chat.copilot.analysis')}</span>
							<span className="text-[11px] bg-violet-100 text-violet-700 px-2 py-0.5 rounded ml-2">/s</span>
							<span className="text-[11px] text-slate-500">{t('chat.copilot.commands.summary')}</span>
						</div>
					</div>
				</div>
			)}

			{/* Sugestão do copilot */}
			{copilotEnabled && text !== '/' && (suggestion || loadingSuggestion) && (
				<div
					className={`relative w-full transition-opacity duration-300 ${suggestion || loadingSuggestion ? "opacity-100" : "opacity-0"}`}
					tabIndex={0}
				>
					<div className="py-1 flex flex-row bg-violet-50 border border-violet-200 rounded items-center px-2">
						<Iconify icon="mingcute:ai-line" className="text-violet-600 mr-2 flex-shrink-0" width={16} height={16} />

						<div className="flex-1 min-w-0 overflow-hidden">
							{loadingSuggestion ? (
								<p className='text-[12px] text-violet-400 italic'>
									{detectCommand(text) ? t('chat.copilot.generating') : t('chat.copilot.suggesting')}
								</p>
							) : (
								<p className='text-[12px]'>
									{detectCommand(text) ? (
										// Para comandos: mostra só a sugestão
										<span className="text-slate-700">{suggestion}</span>
									) : (
										// Para autocomplete: mostra texto + sugestão
										<>
											<span className="text-slate-700">{text}</span>
											<span className="text-violet-500 font-medium"> {suggestion}</span>
										</>
									)}
								</p>
							)}
						</div>

						{suggestion && !loadingSuggestion && (
							<span className="text-[10px] text-violet-400 ml-2 whitespace-nowrap bg-violet-100 px-1.5 py-0.5 rounded">
								Tab ↹
							</span>
						)}
					</div>
				</div>
			)}



			<div className="w-full p-2 flex flex-col">
				<div className="flex flex-col">
					<div className="flex flex-row">
						{loadingSendText ? (
							<div className="w-1/5 h-5 pt-1">
								<Progress value={undefined} className="h-1" />
							</div>
						) : (
							<div className='w-full flex items-center justify-between flex-wrap gap-y-1'>
								<div className="flex items-center gap-1 flex-row flex-wrap">

									<div className="flex flex-row items-center flex-shrink-0">
										<Button
											variant="ghost"
											size="icon"
											onClick={() => setMultiFile(true)}
											disabled={shouldBlockWhatsAppBusiness()}
											className="h-8 w-8"
										>
											<Paperclip
												className={`h-4 w-4 ${shouldBlockWhatsAppBusiness() ? 'text-gray-400' : 'text-slate-800'}`}
											/>
										</Button>
										{isDesktop && (
											<EmojiPicker
												disabled={disabled || shouldBlockWhatsAppBusiness()}
												value={text}
												setValue={setText}
											/>
										)}
										<TooltipProvider>
											<Tooltip>
												<TooltipTrigger asChild>
													<Button
														variant="ghost"
														size="icon"
														onClick={handleClickOpenDialogRespostasRapidas}
														disabled={shouldBlockWhatsAppBusiness()}
														className="h-8 w-8"
													>
														<MessageSquareShare
															className={`h-4 w-4 ${shouldBlockWhatsAppBusiness() ? 'text-gray-400' : 'text-slate-800'}`}
														/>
													</Button>
												</TooltipTrigger>
												<TooltipContent>
													{t('chat.input.quickReplies')}
												</TooltipContent>
											</Tooltip>
										</TooltipProvider>
										{(verifyRules(user.rules, 'ia.analise-atendimento') || verifyRules(user.rules, 'chatgpt')) && (
											<DropdownMenu>
												<DropdownMenuTrigger asChild>
													<Button variant="ghost" size="icon" className="h-8 w-8">
														<Sparkles className='text-violet-800 h-4 w-4' />
													</Button>
												</DropdownMenuTrigger>
												<DropdownMenuContent>
													<DropdownMenuItem onClick={onOpenDrawerGpt}>
														{t('chat.copilot.title')}
													</DropdownMenuItem>

													{verifyRules(user.rules, 'ia.analise-atendimento') && (
														<DropdownMenuItem onClick={onCreateAnalysis} disabled={loadingAnalysis}>
															{loadingAnalysis ? (
																<div className="flex items-center gap-2">
																	<Loader2 className="h-4 w-4 animate-spin" />
																	<span>{t('chat.aiAnalysis.running')}</span>
																</div>
															) : (
																t('chat.aiAnalysis.title')
															)}
														</DropdownMenuItem>
													)}



												</DropdownMenuContent>
											</DropdownMenu>
										)}

										{/* {verifyRules(user.rules, 'chatgpt') || verifyRules(user.rules, 'analise') && (
									
										)} */}
									</div>
									<div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
										<TooltipProvider>
											<Tooltip>
												<TooltipTrigger asChild>
													<Button
														variant="ghost"
														size="icon"
														onClick={() => setOpenModalProduct(true)}
														disabled={shouldBlockWhatsAppBusiness()}
														className="h-8 w-8 mr-1"
													>
														<Iconify icon="solar:box-bold" className="text-violet-600" width={20} height={20} />
													</Button>
												</TooltipTrigger>
												<TooltipContent>
													{t('chat.input.searchProduct')}
												</TooltipContent>
											</Tooltip>
										</TooltipProvider>

										{/* Só mostra switches quando não há bloqueio */}
										{!shouldBlockWhatsAppBusiness() && (
											<>
												<Switch
													checked={assinarEnvio}
													onCheckedChange={handleChangeAssinarEnvio}
													id="assinar-mode" />
												<Label htmlFor="assinar-mode" className="hidden sm:inline">{t('chat.input.sign')}</Label>

												<div className="border-l border-slate-300 h-4 mx-1 sm:mx-2 hidden sm:block" />

												{/* <Tooltip title="Sugestões de texto com IA (Tab para aceitar)">
													<div className="flex items-center space-x-1">
														<Switch
															checked={copilotEnabled}
															onCheckedChange={handleToggleCopilot}
															id="copilot-mode"
															className="data-[state=checked]:bg-violet-600"
														/>
														<Label htmlFor="copilot-mode" className="flex items-center gap-1 cursor-pointer">
															<Iconify icon="mingcute:ai-line" className={copilotEnabled ? "text-violet-600" : "text-slate-400"} width={14} height={14} />
															<span className="text-xs">Copilot</span>
														</Label>
													</div>
												</Tooltip> */}
											</>
										)}
									</div>
									{chat?.canal === "whatsapp_business" && chat?.lastDateMsgClient && (
										<WhatsAppCountdownTimer dataUltimaMensagem={chat.lastDateMsgClient} />
									)}
								</div>



								<NotesPopover
									open={openPopoverNotes}
									setOpen={setOpenPopoverNotes}
									textNotes={textNotes}
									setTextNotes={setTextNotes}
									handleAddNote={handleAddNote}
								/>

								{/* Contador de tempo para WhatsApp Business */}


								{/* {chat?.canal === "instagram" && (
									<Tooltip title="Tempo restante para interação com o contato">
										<Stack spacing={.3} direction={"row"} alignItems={"center"}>
											<Iconify color="primary" icon="mingcute:time-line" width={18} height={18} />
											<CountdownTimer sx={{ ml: 2 }} targetDate={chat?.instagramUser?.lastDateMessageUser ? chat?.instagramUser?.lastDateMessageUser : "2024-05-54T21:00:00"} />
										</Stack>
									</Tooltip>
								)} */}
							</div>
						)}

					</div>



					<div className="flex flex-row items-center">
						{/* Verifica se deve bloquear WhatsApp Business */}
						{shouldBlockWhatsAppBusiness() ? (
							// Mostra apenas botão para templates quando tempo expirou
							<div
								className="flex items-center justify-between w-full bg-red-50 border border-red-200 rounded-lg px-3 py-2 mt-2 cursor-pointer hover:bg-red-100 transition-colors"
								onClick={() => setDialogTemplates(true)}
							>
								<div className="flex items-center gap-2">
									<Iconify
										icon="mingcute:time-line"
										color="error"
										width={18}
										height={18}
									/>
									<div>
										<p className="text-xs text-red-600 font-medium">
											{shouldBlockForMissingLastDate() ? t('chat.input.businessBlock.noClientContact') : t('chat.input.businessBlock.windowExpired')}
										</p>
										<p className="text-xs text-red-500">
											{t('chat.input.businessBlock.clickToUseTemplates')}
										</p>
									</div>
								</div>
								<Iconify
									icon="mingcute:arrow-right-line"
									color="error"
									width={16}
									height={16}
								/>

							</div>
						) : (
							// Input normal quando tempo não expirou
							<div className="relative flex-1 mt-2">
								<Textarea
									ref={textareaRef}
									disabled={loadingSendText}
									value={text}
									rows={2}
									onPaste={handleOnPaste}
									onKeyDown={handleKeyDown}
									onKeyUp={handleKeyUp}
									onChange={onChangeText}
									className={`pl-2 pr-9 text-sm font-normal bg-slate-50 w-full ${isExpanded ? 'min-h-[320px] max-h-[60vh]' : 'min-h-[60px] max-h-[200px]'} resize-none`}
									placeholder={loadingSendText ? t('chat.input.sending') : t('chat.input.placeholderGeneric')}
								/>
								<TooltipProvider>
									<Tooltip>
										<TooltipTrigger asChild>
											<button
												type="button"
												onClick={() => setIsExpanded(v => !v)}
												className="absolute top-2 right-2 p-1 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-200/70 transition-colors"
												aria-label={isExpanded ? t('chat.input.reduceField') : t('chat.input.expandField')}
											>
												{isExpanded ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
											</button>
										</TooltipTrigger>
										<TooltipContent side="top">
											{isExpanded ? t('chat.input.reduce') : t('chat.input.expand')}
										</TooltipContent>
									</Tooltip>
								</TooltipProvider>
							</div>
						)}



						{text.length > 0 ? (
							<Button variant="ghost" size="icon" onClick={sendMessage} className="h-10 w-10 ml-2">
								<Send className="h-5 w-5 text-primary" />
							</Button>
						) : (
							<>
								{/* Só mostra botões de gravação quando não há bloqueio */}
								{!shouldBlockWhatsAppBusiness() && (
									<>
										{recording ? (
											<div className="flex items-center gap-2 ml-2">
												<Button
													variant="ghost"
													size="icon"
													aria-label="cancelRecording"
													disabled={loading}
													onClick={v2_handleCancelAudio}
													className="h-10 w-10"
												>
													<X className="h-5 w-5 text-red-500" />
												</Button>
												{loading ? (
													<Loader2 className="h-5 w-5 animate-spin text-primary" />
												) : (
													<RecordingTimer />
												)}

												<Button
													variant="ghost"
													size="icon"
													aria-label="sendRecordedAudio"
													onClick={v2_stopRecording}
													disabled={loading}
													className="h-10 w-10"
												>
													<Check className="h-5 w-5 text-green-500" />
												</Button>
											</div>
										) : (
											<Button
												variant="ghost"
												size="icon"
												disabled={loading}
												onClick={v2_startRecording}
												className="h-10 w-10 ml-2"
											>
												<Mic className="h-5 w-5 text-primary" />
											</Button>
										)}
									</>
								)}
							</>
						)}

						{/* <input {...getInputProps()} /> */}
					</div>
				</div>
			</div>
		</Card>
	);
}

export default ChatBottomBar;
